export default "__VITE_ASSET__86520930__"